import React, { useState, useEffect, useContext } from "react";
import { ClientContext } from "../../../contexts/ClientContext";
import Color from "color";

const ColorGradient = ({ pickedColor, rowLabel }) => {
  const [activeGradientSquare, setActiveGradientSquare] = useState(null);

  const { currentSet } = useContext(ClientContext);

  // Set an active class for 1.5 seconds so that we can apply some css to have a cool animation of a checkbox
  useEffect(() => {
    const timerId = setInterval(() => {
      setActiveGradientSquare(null);
    }, 1500);

    return () => {
      clearInterval(timerId);
    };
  }, [activeGradientSquare]);

  // On gradient square click we will want to copy the hex color to the clipboard and then set the active class
  const handleClick = (hexColor, gradientOption) => {
    navigator.clipboard.writeText(hexColor);
    setActiveGradientSquare(gradientOption);
  };

  // Rendering the gradient squares
  const gradientRendered = currentSet.ColorRows[rowLabel].gradientOptions.map((gradientOption) => {
    // If the selected color is in the same gradient option we don't want to manipulate the color but we want to notify the user
    const colorIsGradientOption = gradientOption.isGradientOption;

    // If the color inputted is the gradient option change to a circle instead of a square
    const borderRadius = colorIsGradientOption ? "50%" : "100";

    // Need to check the color of the background to know what color the text should be
    const textColor = Color(gradientOption.gradientHex).isLight() ? "black" : "white";

    // On click the active gradient square will update to have this copied class added to it for 1.5s
    const isGradientClicked =
      activeGradientSquare === gradientOption.gradientOption ? "copied" : "";

    return (
      <div
        className="gradient-option"
        key={`${rowLabel}-${pickedColor}-${gradientOption.gradientOption}`}>
        <div
          className="gradient-square"
          style={{
            backgroundColor: gradientOption.gradientHex,
            color: textColor,
            borderRadius: borderRadius,
          }}
          key={`${rowLabel}-${gradientOption.gradientHex}-${gradientOption.gradientOption}`}
          onClick={() => handleClick(gradientOption.gradientHex, gradientOption.gradientOption)}>
          <span className={`gradient-copy-img ${isGradientClicked}`}></span>
        </div>
        <p className="gradient-option-label">{`${gradientOption.gradientOption}`}</p>
      </div>
    );
  });

  return <div className="gradient-square-container">{gradientRendered}</div>;
};

export default ColorGradient;
